import '@vfde-brix/system-icon/dist/styles.css';
import '@vfde-brix/icon/dist/styles.css';

import { createIconComponent } from '@vfde-brix/icon';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const elements = document.getElementsByClassName('brix-icon-pattern');

for (let i = 0, x = elements.length; i < x; i += 1) {

    createIconComponent(elements[i].parentElement, NO_PATTERN_BUSINESS_LOGIC);

}
